import type { PluginFunc } from 'dayjs';

import { dayDiffFromNow as _dayDiffFromNow } from './dayDiffFromNow';

/**
 * @see {@link https://velog.io/@newwwbi/%ED%83%80%EC%9E%85%EC%8A%A4%ED%81%AC%EB%A6%BD%ED%8A%B8%EC%97%90%EC%84%9C-Dayjs-%ED%94%8C%EB%9F%AC%EA%B7%B8%EC%9D%B8-%EB%A7%8C%EB%93%9C%EB%8A%94-%EB%B0%A9%EB%B2%95}
 */
declare module 'dayjs' {
  /**
   * 오늘로부터 몇 일이 지났는지 반환
   *
   * @example
   * ```
   * // now: 2022-11-16
   * dayjs.dayDiffFromNow('2022-11-13') // => 3
   * ```
   */
  export function dayDiffFromNow(dateString: string): number;
}

/**
 * @see {@link https://day.js.org/docs/en/plugin/plugin Dayjs plugin}
 */
const dayDiffFromNowPlugin: PluginFunc = (_option, _dayjsClass, dayjsFactory) => {
  dayjsFactory.dayDiffFromNow = function (dateString) {
    return _dayDiffFromNow(dateString);
  };
};

export default dayDiffFromNowPlugin;
